import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { listAnnouncement } from "../../server/apihelper";
import Confetti from "react-confetti";

export const Announcement = () => {
  const [announcementList, setAnnouncementList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    AOS.init();
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const query = "page=1&items_per_page=10&type=1";
    listAnnouncement(query).then((res) => {
      setAnnouncementList(res.data);
    });
  }, []);

  useEffect(() => {
    if (announcementList.length > 0) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [announcementList]);

  const getIcon = (title) => {
    const iconMappings = {
      graduation: "🎓",
      award: "🏆",
      celebration: "🎉",
      alert: "⚠️",
      announcement: "📢",
      alumni: "🤝",
      meet: "🧑‍🤝‍🧑",
      sports: "🏅",
      farewell: "👋",
      day: "🌟",
      default: "✨",
    };

    for (const keyword in iconMappings) {
      if (title.toLowerCase().includes(keyword)) {
        return iconMappings[keyword];
      }
    }

    return iconMappings.default;
  };

  const options = {
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  return (
    <>
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1500,
            padding: "20px",
          }}
        >
          {/* Modal Container */}
          <div
            data-aos="zoom-in"
            className="announcement-modal-box"
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "700px",
              maxHeight: "90vh",
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.4)",
              overflowY: "auto",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Confetti Background - Higher Z-index to be on top but pointer-events: none */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                zIndex: 10,
                overflow: "hidden",
              }}
            >
              <Confetti
                width={700}
                height={1000}
                numberOfPieces={200}
                gravity={0.15}
                colors={["#FFD700", "#FF4500", "#1E90FF", "#32CD32", "#FF69B4"]}
                recycle={true}
              />
            </div>

            {/* Close Button - Stays fixed at the top right of the modal box */}
            <div
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                width: "32px",
                height: "32px",
                backgroundColor: "#d63031",
                color: "white",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                zIndex: 100,
                boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              &times;
            </div>

            {/* Content Area */}
            <div style={{ padding: "40px 20px 30px" }}>
              {announcementList?.map((announcement, index) => (
                <div key={index} style={{ marginBottom: "40px" }}>
                  {/* Title with Sparkles */}
                  <h3
                    style={{
                      fontSize: "26px",
                      marginBottom: "25px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#333",
                      fontWeight: "700",
                    }}
                  >
                    <span style={{ marginRight: "10px", fontSize: "30px" }}>✨</span>
                    {announcement.title}
                    <span style={{ marginLeft: "10px", fontSize: "30px" }}>✨</span>
                  </h3>

                  {/* Banner Image */}
                  <div style={{ width: "100%", marginBottom: "25px" }}>
                    <a
                      href={
                        announcement.announcementlink.startsWith("http")
                          ? announcement.announcementlink
                          : `https://${announcement.announcementlink}`
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={announcement.image}
                        alt={announcement.title}
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                          borderRadius: "5px",
                        }}
                      />
                    </a>
                  </div>

                  {/* Description */}
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "16px",
                      lineHeight: "1.6",
                      color: "#444",
                      padding: "0 10px",
                    }}
                  >
                    <p style={{ fontWeight: "600", whiteSpace: "pre-wrap" }}>
                      {announcement.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 🔹 Custom Scrollbar Styling */}
          <style>
            {`
              .announcement-modal-box::-webkit-scrollbar {
                width: 10px;
              }
              .announcement-modal-box::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 0 20px 20px 0;
              }
              .announcement-modal-box::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 10px;
              }
              .announcement-modal-box::-webkit-scrollbar-thumb:hover {
                background: #555;
              }

              @media (max-width: 768px) {
                .announcement-modal-box {
                  width: 95% !important;
                  max-height: 95vh;
                }
                .announcement-modal-box h3 {
                  font-size: 20px !important;
                }
              }
            `}
          </style>
        </div>
      )}
    </>
  );
};
